'use client'

/***
 *
 * @file components/LanguageChanger/index.tsx
 * @description LanguageChanger component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { ChangeEvent, useEffect, useState } from "react";
import { useParams, usePathname, useRouter, useSearchParams } from "next/navigation";
import { getDefaultLocale, getLocale } from "@/config/app.config";
import Cookies from 'js-cookie';

type Props = {
  localeList: string[];
  locale: string; // comes from server
  defaultLocale?: string;
};

const LanguageChanger = ({
  localeList = [],
  locale,
  defaultLocale = getDefaultLocale()
}: Props) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = useParams();

  const [selectedLocale, setSelectedLocale] = useState<string>(getLocale());
  const [locales, setLocales] = useState<string[]>(localeList)
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    // setLocales(localeList);
    // setSelectedLocale(locale);
    const segments = pathname.split("/").filter(Boolean);
    const currentPath = segments.slice(1).join("/");
    const searchString = searchParams.toString();
    const searchSuffix = searchString ? `?${searchString}` : "";
    (localeList || [locale]).forEach((loc) => router.prefetch(`/${loc}/${currentPath}${searchSuffix}`));
    // console.log("Route prefetch --- ", segments)
        
    // console.log("LanguageChanger | locales --- ", localeList);
    setLocales(localeList);
    setSelectedLocale((()=>{
      return Cookies.get("NEXT_LOCALE") || defaultLocale;
    })())
  }, [])

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newLocale = e.target.value;
    // setLoading(true);

    const days = 30;
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/;SameSite=Lax`;

    const isDefault = newLocale === defaultLocale;
    const segments = pathname.split("/").filter(Boolean);   //  ["es", "witw", "abc"] []
    const pathLocale = localeList.includes(segments[0]) ? segments[0] : null;
    // Remove existing locale prefix
    // const pathLocale = localeList.includes(segments[0]) ? segments.shift() : null;

    // /pt/witw
    // segments = ["pt", "witw"]
    // segments.shift();
    // segments = ["witw"]

    // /es/witw

    if (pathLocale && localeList.includes(pathLocale)) { 
        segments.shift();
    }

    // Build clean path with preserved search params
    const searchString = searchParams.toString();
    const newPath = `/${newLocale}/${segments.join("/")}${searchString ? `?${searchString}` : ""}`;

    // Update lang attribute in the html document
    document.documentElement.setAttribute('lang', newLocale);

    // let newPath = "/";
    // if (!isDefault) newPath += `${newLocale}/`;
    // newPath += segments.join("/");
    console.log("LanguageChanger ---- ", { newLocale, isDefault, segments, newPath });
    // setTimeout(() => {
      router.replace(newPath);
    // }, 1);
  };

  return (
      <>
        <select
          id="LanguageChanger"
          name="LanguageChanger"
          title="LanguageChanger"
          className="LanguageChanger"
          data-testid="LanguageChanger"
          style={{ background: "transparent" }}
          onChange={handleChange}
          value={selectedLocale}
        >
          {locales.map((l) => (
            <option key={`LanguageChanger--${l}`} value={l}>
              {l}
            </option>
          ))}
        </select>
        {/* {loading && <span>Switching...</span>} */}
      </>
  );
};

export default LanguageChanger;